import React from "react";
import { useRouter } from "../../util/router";
const NotFoundPage = () => {
  const router = useRouter();
  return (
    <div
      style={{
        padding: "50px",
        width: "100%",
        textAlign: "center",
      }}
    >
      The page <code>{router.pathname}</code> could not be found.
    </div>
  );
};

export default NotFoundPage;
